import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';

/*Actions*/
import {
	getRebatesAndClaims,
} from '../../../../redux/actions';

class ClaimForms extends Component {

	constructor(props) {
		super(props);
		this.state = {
			errorMessage: '',
			claimFormsDocuments: [],
			rebatesDocuments: [],
			// claimFormsDocuments: [{
			// 	name: 'Monogram Rewards 2020',
			// 	pdfName: 'Monogram_2020_ClaimForm_Consumer',
			// }],
			// rebatesDocuments: [{
			// 	name: 'Café Rebate 1H21 – Contract',
			// 	pdfName: '1H2021CafeRebateFormABD',
			// }, {
			// 	name: 'Café Rebate 1H21 – Retail',
			// 	pdfName: '1H2021CafeRebateFormRetail',
			// }, {
			// 	name: 'Profile Rebate 1H21 – Contract',
			// 	pdfName: '1H2021ProfileRebateFormABD',
			// }, {
			// 	name: 'Profile Rebate 1H21 – Retail',
			// 	pdfName: '1H2021ProfileRebateFormRetail',
			// }, {
			// 	name: 'Café Cookware Rebate 1H21',
			// 	pdfName: 'CafeCookwareRebate',
			// }, {
			// 	name: 'Profile Cookware Rebate 1H21',
			// 	pdfName: 'ProfileCookwareRebate',
			// }, {
			// 	name: 'Café Fits Built-In 2021',
			// 	pdfName: 'CafeFitsBuiltin',
			// }, {
			// 	name: 'Café Fits Slide-In 2021',
			// 	pdfName: 'CafeSlideInFits',
			// }, {
			// 	name: 'GE Fits Cooktops 2021',
			// 	pdfName: 'GEFitsCooktops',
			// }, {
			// 	name: 'GE Fits Wall Ovens 2021',
			// 	pdfName: 'GEFItsWallOven',
			// }, {
			// 	name: 'GE Fits Slide-In 2021',
			// 	pdfName: 'GERangeFits',
			// }, {
			// 	name: 'Haier Fits Slide-In 2021',
			// 	pdfName: 'HaierRangeFits',
			// }, {
			// 	name: 'Laundry Pair April 2021 – Retail',
			// 	pdfName: 'RetailStainFreeSpringLaundryRebate',
			// }, {
			// 	name: 'Laundry Pair April 2021 – Contract',
			// 	pdfName: 'ABDStainFreeSpringLaundryRebate',
			// }]
		}
	}
	componentWillMount() {
		const self = this;
		self.props.getRebatesAndClaims('requestType=rebatesAndClaims', (response) => {
			if (response.responseObject) {
				const claimForms = response.responseObject
				.filter(item => item.docGroup === 'Claim Form')
				.sort((a, b) => a.displayName.localeCompare(b.displayName));

				const rebates = response.responseObject
					.filter(item => item.docGroup === 'Rebate')
					.sort((a, b) => a.displayName.localeCompare(b.displayName)); // ✅ Alphabetical sort

				self.setState({
					claimFormsDocuments: claimForms,
					rebatesDocuments: rebates,
				});
			}
		});
	}
	openDocument(pdfFile, event) {
		event && event.preventDefault();
		window.open(pdfFile);
	}
    render() {
		const self = this;
		const { rebatesDocuments, claimFormsDocuments } = self.state;
	    return (
			<div>
				{self.state.errorMessage && <p className="bold red">{self.state.errorMessage}</p>}
				<h1 className="pageTitle">Consumer Rebates</h1>
				<div className="searchResults" style={{borderTop: 'none'}}>
					<table className="dataTable" width="70%">
						<thead>
							<tr>
								<th>Document</th>
							</tr>
						</thead>
						<tbody>
							{rebatesDocuments.map((item, index) => {
								return <tr key={index}>
									<td>
										<a href="" onClick={self.openDocument.bind(this, item.docS3URL)}>
											{item.displayName}
										</a>
									</td>
								</tr>
							})}
							{rebatesDocuments.length === 0
								?<tr>
									<td>
										No document found.
									</td>
								</tr>
								:null
							}
						</tbody>
					</table>
					<div className="clear" />
				</div>
		        <h1 className="pageTitle">Claim Forms</h1>
				<p className="bold red">{this.state.errorMessage}</p>
		        <div className="searchResults" style={{borderTop: 'none'}}>
					<table className="dataTable" width="70%">
						<thead>
							<tr>
								<th>Document</th>
							</tr>
						</thead>
			            <tbody>
							{claimFormsDocuments.map((item, index) => {
								return <tr key={index}>
			  	                	<td>
										<a href="" onClick={self.openDocument.bind(this, item.docS3URL)}>
											{item.displayName}
										</a>
									</td>
			  	              	</tr>
							})}
							{claimFormsDocuments.length === 0
								?<tr>
									<td>
										No document found.
									</td>
								</tr>
								:null
							}
						</tbody>
					</table>
		          	<div className="clear" />
				</div>
			</div>
	    );
  	}
}
const mapStateToProps = (state) => {
	return {state};
};

const mapDispatchToProps = (dispatch) => ({
	getRebatesAndClaims: (queryStringParams, callback) => dispatch(getRebatesAndClaims(queryStringParams, callback)),
});

ClaimForms = connect(mapStateToProps, mapDispatchToProps)(ClaimForms);
export default ClaimForms;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Resources/ClaimForms/index.js